import React from 'react';
import './Footer.css';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn 
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Section principale */}
        <div className="footer-main">
          <div className="footer-brand">
            <h3>ETEF</h3>
            <p>Plateforme d'entraide pour les étudiants africains en France</p>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Navigation</h4>
              <a href="/">Accueil</a>
              <a href="/annonces">Annonces</a>
              <a href="/services">Services</a>
              <a href="/blog">Blog</a>
            </div>

            <div className="link-group">
              <h4>Support</h4>
              <a href="/aide">Centre d'aide</a>
              <a href="/contact">Contact</a>
              <a href="/faq">FAQ</a>
            </div>

            {/* <div className="link-group">
              <h4>Légal</h4>
              <a href="/confidentialite">Confidentialité</a>
              <a href="/conditions">Conditions d'utilisation</a>
              <a href="/cookies">Cookies</a>
            </div> */}
          </div>
        </div>

        {/* Section sociale et copyright */}
        <div className="footer-bottom">
          <div className="social-links">
            <a href="#" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="#" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
          </div>

          <div className="copyright">
            <p>© {currentYear} ETEF. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;